import DataTable from '../../components/data/DataTable';
import DataView from '../../components/data/DataView';
import { PersonListDto } from "../../components/person/PersonList";
import { useIsSystemTenant } from '../../models/Hooks';
import { isMobile } from '../../utils';
import { InhabitantForm } from './InhabitantForm';
import InhabitantList, { inhabitantListColumns } from './InhabitantList';

export function InhabitantTitle({ multiply }: { multiply? :boolean}) {
    const iss = useIsSystemTenant();
    return multiply ? iss ? 'Клиенты' : 'Жильцы' : (iss ? 'Клиент' : 'Жилец');
}

export default function InhabitantView() {
    return <DataView<PersonListDto>
        title={<InhabitantTitle />}
        titleMultiple={<InhabitantTitle multiply={true} />}
        typeId="Inhabitant"
        modes={[{ mode: 'list', hideAddBtn: isMobile() }]}
        form={(id, apiRef) => <InhabitantForm key="main" id={id} apiRef={apiRef} />}
        tableRenderer={p => isMobile() ? <InhabitantList {...p} /> : <DataTable<PersonListDto> {...p} />}
        tableProps={{
            columns: inhabitantListColumns,
            dataParser: PersonListDto.parse
        }} />;
}